var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: 83,
    viewBox: "0 0 120 83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_2068",
    x: 37,
    y: 20,
    width: 46.718,
    height: 46,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.38
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1436",
    "data-name": "Grupo 1436",
    transform: "translate(0 -997)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_17006",
    "data-name": "Rect\\xE1ngulo 17006",
    width: 120,
    height: 83,
    transform: "translate(0 997)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 997)",
    filter: "url(#Trazado_2068)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2068-2",
    "data-name": "Trazado 2068",
    d: "M66.039,55.738c-1.543-4.963-6.438-8.35-12.307-8.45v-5.8a.516.516,0,0,0-.5-.5.541.541,0,0,0-.3.1l-14.922,10.8a.49.49,0,0,0-.1.7l.1.1,14.922,10.73a.52.52,0,0,0,.7-.1.541.541,0,0,0,.1-.3V57.247c3.622,0,6.673,1.71,7.746,4.292.905,2.213.168,4.594-1.978,6.572a.487.487,0,0,0-.034.7.538.538,0,0,0,.369.168h.4a.381.381,0,0,0,.268-.1C65.435,65.631,67.548,60.567,66.039,55.738Z",
    transform: "translate(8.2 -14.98)",
    fill: "#e50037"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolver);
export default __webpack_public_path__ + "static/media/Volver.203ae8cd2bccd06372be035112fbda59.svg";
export { ForwardRef as ReactComponent };